/*
SPDX-FileCopyrightText: 2025 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/

import React from "react";
import { CentreContents } from "@tol/tol-ui";
import { Link } from "react-router-dom";
import "../../scss/legacy-tol.scss";

const LegacyPublications: React.FC = () => {
  return (
    <div style={{ backgroundColor: "white", color: "black" }}>
      <CentreContents>
        <header className="header">
          <h1 className="header-h1">Tree of sex</h1>
          <h2 className="header-h2">
            a database of eukaryotic sex determination systems
          </h2>
          <nav className="nav">
            <Link className="link" to={"/legacy-home"}>
              Home{" "}
            </Link>
            <Link className="link" to={"/legacy-consortium"}>
              Consortium{" "}
            </Link>
            <Link className="link" to={"/legacy-database"}>
              Database{" "}
            </Link>
            <span>Publications</span>
          </nav>
        </header>
        <main className="legacy-main">
          <p>
            Here a list of publications that have resulted from the Tree of Sex
            working group.
          </p>
          <ul className="pub">
            <li>
              The Tree of Sex Consortium (2014). {" "}
              <a
                className="link"
                href="http://www.plosbiology.org/article/info%3Adoi%2F10.1371%2Fjournal.pbio.1001899"
                target="_blank"
              >
                Sex determination: Why so many ways of doing it? {" "}
              </a>
              <strong>
                <em>PLoS Biology</em>
              </strong>
              , 12(7): e1001899.
            </li>
            <li>
              The Tree of Sex Consortium (2014). {" "}
              <a
                className="link"
                href="http://www.nature.com/articles/sdata201415"
                target="_blank"
              >
                Tree of Sex: A database of sexual systems {" "}
              </a>
              <strong>
                <em> Scientific Data</em>
              </strong>
              , 1:140015.{" "}
            </li>
            <li>
              Beukeboom LW, Perrin N (2014).
              <a
                className="link"
                href="http://ukcatalogue.oup.com/product/9780199657148.do"
                target="_blank"
              >
                The Evolution of Sex Determination.
              </a>{" "}
              Oxford University Press, 240 pp
            </li>
            <li>
              Otto SP (2014). {" "}
              <a
                className="link"
                href="http://onlinelibrary.wiley.com/doi/10.1111/jeb.12324/abstract;jsessionid=676DC9CAF9B69599C7E0EF54DE9BBF09.f01t02"
                target="_blank"
              >
                Selective maintenance of recombination between the sex
                chromosomes {" "}
              </a>
              <strong>
                <em>J. Evolutionary Biology</em>
              </strong>
              , 27(7): 1431-1442.
            </li>
            <li>
              Blackmon H. &amp; Demuth, JP (2014) {" "}
              <a
                className="link"
                href="http://www.genetics.org/content/197/2/561"
                target="_blank"
              >
                Estimating Tempo and Mode of Y Chromosome Turnover: Explaining Y
                Chromosome Loss With the Fragile Y Hypothesis. {" "}
              </a>
              <strong>
                <em>Genetics,</em>
              </strong>{" "}
              197, 561-572 (2014).
            </li>
            <li>
              Normark BB &amp; Ross L (2014). {" "}
              <a
                className="link"
                href="http://rstb.royalsocietypublishing.org/content/369/1642/20130364.long"
                target="_blank"
              >
                Genetic conflict, kin and the origins of novel genetic systems {" "}
              </a>
              <strong>
                <em>Phil. Trans. R. Soc. B.,</em>
              </strong>{" "}
              369(1642):20130364.
            </li>
            <li>
              Ross L, Blackmon H, Lorite P, Gokhman VE &amp; Hardy NB. {" "}
              <a
                className="link"
                href="https://onlinelibrary.wiley.com/doi/abs/10.1111/jeb.12543"
                target="_blank"
              >
                Recombination, genome architecture and eusociality in the
                Hymenoptera. {" "}
              </a>
              <strong>
                <em>Journal of Evolutionary Biology,</em>
              </strong>{" "}
              28:1 105-116.
            </li>
            <li>
              Blackmon H, Ross L, Bachtrog D. (2014). {" "}
              <a
                className="link"
                href="https://academic.oup.com/jhered/article-abstract/108/1/78/2631559"
                target="_blank"
              >
                Sex determination, sex chromosomes and karyotype evolution in
                insects. {" "}
              </a>
              <strong>
                <em>Journal of Heredity,</em>
              </strong>{" "}
              108:1 78-93.
            </li>
            <li>
              Blackmon, H., Hardy, N.B. &amp; L. Ross. {" "}
              <a
                className="link"
                href="https://onlinelibrary.wiley.com/doi/abs/10.1111/evo.12792"
                target="_blank"
              >
                The evolutionary dynamics of haplodiploidy in Mites (Acari). {" "}
              </a>
              <strong>
                <em>Evolution,</em>
              </strong>{" "}
              69:11 2971-2978
            </li>
            <li>
              Goldberg, E. E., Otto, S. P., Vamosi, J. C., Mayrose, I., Sabath,
              N., Ming, R., &amp; Ashman, T-L. (2017). {" "}
              <a
                className="link"
                href="https://onlinelibrary.wiley.com/doi/abs/10.1111/evo.13181"
                target="_blank"
              >
                Macroevolutionary synthesis of flowering plant sexual systems. {" "}
              </a>
              <strong>
                <em>Evolution,</em>
              </strong>{" "}
              71, 898-912.
            </li>
            <li>
              Pennell, M. W., Kirkpatrick, M., Otto, S. P., Vamosi, J. C.,
              Peichel, C. L., Valenzuela, N., &amp; Kitano, J. (2015). {" "}
              <a
                className="link"
                href="https://journals.plos.org/plosgenetics/article?id=10.1371/journal.pgen.1005237"
                target="_blank"
              >
                Y Fuse? Sex chromosome fusions in fishes and reptiles. {" "}
              </a>
              <strong>
                <em>PLoS Genetics,</em> {" "}
              </strong>{" "}
              11, e1005237.
            </li>
            <li>
              Pennell, M. W., Mank, J. E., &amp; Peichel, C. L. (2018). {" "}
              <a
                className="link"
                href="https://onlinelibrary.wiley.com/doi/abs/10.1111/mec.14540"
                target="_blank"
              >
                Transitions in sex determination and sex chromosomes across
                vertebrate species. {" "}
              </a>
              <strong>
                <em>Molecular Ecology,</em>
              </strong>{" "}
              27, 3950-3963.
            </li>
            <li>
              Sabath, N., Goldberg, E. E., Glick, L., Einhorn, M., Ashman, T-L.,
              Ming, R., Otto, S. P., Vamosi, J. C., &amp; Mayrose, I. (2016). {" "}
              <a
                className="link"
                href="https://nph.onlinelibrary.wiley.com/doi/abs/10.1111/nph.13696"
                target="_blank"
              >
                Dioecy does not consistently accelerate or slow lineage
                diversification across multiple genera of angiosperms. {" "}
              </a>
              <strong>
                <em>New Phytologist,</em>
              </strong>{" "}
              209, 1223-1235.
            </li>
            <li>
              Sabath, N., Itescu, Y., Feldman, A., Meiri, S., Mayrose, I., &amp;
              Valenzuela, N. (2016). {" "}
              <a
                className="link"
                href="https://onlinelibrary.wiley.com/doi/abs/10.1002/ece3.2277"
                target="_blank"
              >
                Sex determination, longevity, and the birth and death of
                reptilian species. {" "}
              </a>
              <strong>
                <em>Ecology and Evolution,</em>
              </strong>{" "}
              6, 5207-5220.
            </li>
          </ul>
          <p>
            Several groups have used or expanded on the data collected by the
            project. {" "}
          </p>
          <ul className="pub">
            <li>
              Xirocostas, Z. A., Everingham, S. E., &amp; Moles, A. T. (2020).
              <a
                className="link"
                href="https://royalsocietypublishing.org/doi/abs/10.1098/rsbl.2019.0867"
                target="_blank"
              >
                {" "}
                The sex with the reduced sex chromosome dies earlier: a
                comparison across the tree of life. {" "}
              </a>
              <strong>
                <em>Biology Letters,</em>
              </strong>{" "}
              16, 20190867.
            </li>
            <li>
              Kattge, J. et al. (2020) {" "}
              <a
                className="link"
                href="https://onlinelibrary.wiley.com/doi/abs/10.1111/gcb.14904"
                target="_blank"
              >
                TRY plant trait database - enhanced coverage and open access. {" "}
              </a>
              <strong>
                <em>Global Change Biology,</em>
              </strong>{" "}
              26: 119-188.
            </li>
          </ul>
        </main>
        <footer className="legacy-footer">
          <p>
            &copy; 2014 Tree of Sex Consortium :{" "}
            <Link to={"/legacy-cookies-policy"}>Cookies Policy</Link>
          </p>
        </footer>
      </CentreContents>
    </div>
  );
};
export default LegacyPublications;
